import { render } from "./App.vue?vue&type=template&id=debb8fee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=debb8fee&lang=css"

import exportComponent from "D:\\01. Workspace\\orot_kiosk\\src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__